<style lang="scss" scoped>
  .c-card {
    border: 1px solid hsl(0, 0%, 85%);
    background: white;
  }
  .c-title, .c-content, .c-link {
    padding: 20px;
  }
  .c-content, .c-link {
    padding-top: 0px;
  }
</style>


<template>
  <div class="c-card flex-v flex-limit">
    <img v-if="image" :src="src">
    <div class="c-title is-size-4"><slot name="title"></slot></div>
    <div class="c-content"><v-clamp autoresize :max-lines="5"><slot name="content"></slot></v-clamp></div>
    <div class="c-link"><a :href="link">See more...</a></div>
  </div>
</template>


<script>
import VClamp from 'vue-clamp';


export default {
  name: 'card',
  props: ['image', 'link'],
  components: {
    VClamp
  },
  computed: {
    src() {return require('@/assets/images/' + this.image);}
  }
};
</script>
